// Availability status helpers

export const getStatusLabel = (status, quantityAvailable) => {
  switch (status) {
    case 'sold_out':
      return 'Sold Out';
    case 'low':
      return `Only ${quantityAvailable} spots left`;
    case 'available':
      return 'Available';
    default:
      return '';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'available':
      return '#4caf50';
    case 'low':
      return '#ff9800';
    case 'sold_out':
      return '#f44336';
    default:
      return '#9e9e9e';
  }
};

export const getStatusBgColor = (status) => {
  switch (status) {
    case 'available':
      return 'rgba(76, 175, 80, 0.1)';
    case 'low':
      return 'rgba(255, 152, 0, 0.1)';
    case 'sold_out':
      return 'rgba(244, 67, 54, 0.08)';
    default:
      return 'rgba(0,0,0,0.04)';
  }
};

export const getStatusBorderColor = (status) => {
  switch (status) {
    case 'available':
      return 'rgba(76, 175, 80, 0.3)';
    case 'low':
      return 'rgba(255, 152, 0, 0.5)';
    case 'sold_out':
      return 'rgba(244, 67, 54, 0.3)';
    default:
      return '#e0e0e0';
  }
};
